import api from 'api/module/role'
import store from '@/store'

import setEntryUrl from '@/env/setEntryUrl.js'

console.log('开始测试： 11111111111')

// 获取当前登录的组织和账户信息
function getAppIdPrex(orgId) {
  const lastLoginOrgs =
    JSON.parse(localStorage.getItem('pc:lastLoginOrg')) || []
  const findCurrentOrg = lastLoginOrgs.find(
    (item) =>
      item.accountId ===
      store.state.keycloakToken.tokenParsed.sub
  )
  console.log(findCurrentOrg, '测试 org')
  const appIdPrex =
    'orgId_' +
    (findCurrentOrg ? findCurrentOrg.orgId : orgId) +
    '_accId_' +
    (findCurrentOrg
      ? findCurrentOrg.accountId
      : store.state.keycloakToken.tokenParsed.sub) +
    '_appId_'
  return appIdPrex
}

// 获取微应用列表信息
async function getAllOrgNav() {
  let appList = []
  await api({
    name: 'getAllOrgNav',
    data: {},
    _this: this,
  }).then((res) => {
    let allUrls = res.data.resultBody
    console.log(res, 'res')
    const lastLoginOrgs =
      JSON.parse(localStorage.getItem('pc:lastLoginOrg')) || []
    if (Object.prototype.toString.call(lastLoginOrgs) === '[object Array]') {
      const findCurrentOrg = lastLoginOrgs.find(
        (item) =>
          item.accountId ===
          store.state.keycloakToken.tokenParsed.sub
      )

      const currentOrgApp = allUrls.find(
        (org) => org.orgId === findCurrentOrg?.orgId
      )
      let orgId2List = allUrls.find((item) => item.orgId === 2)
      appList = currentOrgApp ? currentOrgApp.list : allUrls[0]?.list || []

      if (currentOrgApp) {
        appList = currentOrgApp.list
      }
      if (!currentOrgApp && orgId2List) {
        appList = orgId2List?.list || []
      }
      if (!currentOrgApp && !orgId2List) {
        appList = allUrls[0]?.list || []
      }
    }
    const externalList = getElectronExternalUrl()
    appList.push(...externalList)
    console.log(appList, 'appList')
    store.dispatch('setAppsInOrgs', allUrls)
    store.dispatch('setAppsInOrg', appList)
    appList = appList.filter((app) => app.microFrontFlag === '1')
    const appIdPrex = getAppIdPrex(allUrls[0].orgId)
    console.log(appIdPrex)
    appList = appList.map((app) => {
      app.uiUri = app.uiUri.replace(/^null/, 'http://')
      app.sevUri = app.sevUri.replace(/^null/, 'http://')
      const entryUrl = setEntryUrl(app.uiUri, app.appName)
      return {
        ...app,
        id: app.appName,
        name: app.appName,
        entry: entryUrl,
        container: '#' + app.appName,
        activeRule: '/' + app.appName,
      }
    })
    store.dispatch('setCurrentMicroApps', appList)
  })
  return appList
}

function getElectronExternalUrl() {
  let externalList = [
    {
      appName: 'electron-external-app',
      microFrontFlag: '0',
      sevUri: 'https://sitir.net',
      uiUri: 'https://sitir.net',
    },
  ]
  return externalList
}

export default getAllOrgNav
